import React, { useState } from 'react';
import { Star, Award, BookOpen, Users, Phone, Mail, MessageCircle, Upload, Eye, ArrowLeft } from 'lucide-react';
import { sendEmail } from '../services/emailService';

const Legends = () => {
  const [showApplication, setShowApplication] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedLegend, setSelectedLegend] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    organization: '',
    profile: '',
    whatsapp: '',
    contact: '',
    email: '',
    photo: null
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const legends = [
    {
      name: "Dr. A.P.J. Abdul Kalam",
      designation: "Former President of India",
      organization: "DRDO, ISRO",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Renowned aerospace scientist and statesman who served as the 11th President of India. Known as the 'Missile Man of India' for his work on ballistic missile and launch vehicle technology. His contributions to India's civilian space programme and military missile development earned him national acclaim. A visionary leader who inspired millions through his teachings on education, innovation, and youth empowerment.",
      whatsapp: "+91 98765 43210",
      contact: "+91 98765 43210",
      email: "kalam@drdo.gov.in"
    },
    {
      name: "Prof. C.N.R. Rao",
      designation: "Bharat Ratna Awardee",
      organization: "JNCASR, Bangalore",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Distinguished chemist and materials scientist, recipient of Bharat Ratna, India's highest civilian honor. Pioneer in solid-state and structural chemistry with over 1600 research publications. His groundbreaking work in nanomaterials and carbon nanotubes has revolutionized materials science. Mentor to thousands of students and researchers worldwide, continuing to inspire scientific excellence at age 89.",
      whatsapp: "+91 98765 43211",
      contact: "+91 98765 43211",
      email: "cnrrao@jncasr.ac.in"
    },
    {
      name: "Dr. Tessy Thomas",
      designation: "Missile Woman of India",
      organization: "DRDO",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "First woman scientist to head a missile project in India, leading the Agni-IV missile development. Her exceptional leadership in aerospace engineering has broken gender barriers in defense technology. Known for her innovative approach to missile guidance systems and propulsion technology. A role model for women in STEM fields, advocating for greater female participation in defense research.",
      whatsapp: "+91 98765 43212",
      contact: "+91 98765 43212",
      email: "tessy.thomas@drdo.gov.in"
    },
    {
      name: "Prof. Raghunath Anant Mashelkar",
      designation: "Former Director General",
      organization: "CSIR",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Eminent chemical engineer and former Director General of CSIR, known for transforming India's scientific research landscape. Pioneer in polymer science and engineering with over 350 research papers. His leadership revolutionized technology transfer and innovation in Indian laboratories. Advocate for inclusive innovation and affordable healthcare solutions for developing nations.",
      whatsapp: "+91 98765 43213",
      contact: "+91 98765 43213",
      email: "ramashelkar@csir.res.in"
    },
    {
      name: "Dr. Kiran Mazumdar-Shaw",
      designation: "Executive Chairperson",
      organization: "Biocon Limited",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Pioneering biotechnology entrepreneur who founded Biocon, India's largest biopharmaceutical company. Her vision transformed biotechnology landscape in India, making life-saving drugs accessible globally. Recognized internationally for contributions to biotechnology and healthcare innovation. Passionate advocate for affordable healthcare and women's empowerment in entrepreneurship and science.",
      whatsapp: "+91 98765 43214",
      contact: "+91 98765 43214",
      email: "kiran@biocon.com"
    },
    {
      name: "Prof. Ashutosh Sharma",
      designation: "Former Secretary",
      organization: "DST, Government of India",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Distinguished materials scientist and former Secretary of Department of Science and Technology. Expert in interfacial engineering and thin film science with significant contributions to nanotechnology. His leadership strengthened India's science and technology infrastructure through policy reforms. Advocate for international scientific collaboration and technology-driven economic growth.",
      whatsapp: "+91 98765 43215",
      contact: "+91 98765 43215",
      email: "ashutosh@dst.gov.in"
    },
    {
      name: "Dr. Shanti Swarup Bhatnagar",
      designation: "Father of Research in India",
      organization: "CSIR",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Founding father of scientific research in India and first Director General of CSIR. His vision established the foundation of modern scientific research infrastructure in independent India. Pioneer in colloid chemistry and emulsion science with groundbreaking research contributions. The prestigious Shanti Swarup Bhatnagar Prize for Science and Technology is named in his honor.",
      whatsapp: "+91 98765 43216",
      contact: "+91 98765 43216",
      email: "ssbhatnagar@csir.res.in"
    },
    {
      name: "Prof. Yash Pal",
      designation: "Renowned Physicist",
      organization: "TIFR, Mumbai",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Celebrated physicist and science communicator who made complex scientific concepts accessible to common people. His contributions to cosmic ray physics and space research earned international recognition. Pioneer in science education and popularization through television programs and books. His passion for making science understandable inspired generations of students and researchers.",
      whatsapp: "+91 98765 43217",
      contact: "+91 98765 43217",
      email: "yashpal@tifr.res.in"
    },
    {
      name: "Dr. Raghavan Varadarajan",
      designation: "Molecular Biophysicist",
      organization: "IISc, Bangalore",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Leading molecular biophysicist specializing in protein folding and stability studies. His research on protein engineering and drug design has significant implications for therapeutic development. Pioneer in understanding molecular mechanisms of protein function and dysfunction. His work bridges fundamental research with practical applications in biotechnology and medicine.",
      whatsapp: "+91 98765 43218",
      contact: "+91 98765 43218",
      email: "varadarajan@iisc.ac.in"
    },
    {
      name: "Prof. Indira Nath",
      designation: "Immunologist",
      organization: "AIIMS, New Delhi",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Distinguished immunologist and pathologist known for groundbreaking research in leprosy and tuberculosis. Her work on host-pathogen interactions has advanced understanding of infectious diseases. Pioneer in immunopathology with significant contributions to medical education and research. Advocate for women in medical research and public health policy development.",
      whatsapp: "+91 98765 43219",
      contact: "+91 98765 43219",
      email: "indira.nath@aiims.edu"
    },
    {
      name: "Dr. G. Madhavan Nair",
      designation: "Former Chairman",
      organization: "ISRO",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Visionary space scientist who led India's space program to new heights during his tenure as ISRO Chairman. His leadership resulted in successful missions including Chandrayaan-1 and multiple satellite launches. Expert in satellite technology and space applications with contributions to remote sensing and communication satellites. His strategic vision positioned India as a major player in global space technology.",
      whatsapp: "+91 98765 43220",
      contact: "+91 98765 43220",
      email: "madhavan@isro.gov.in"
    },
    {
      name: "Prof. M.S. Swaminathan",
      designation: "Father of Green Revolution",
      organization: "MSSRF, Chennai",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Agricultural scientist who spearheaded India's Green Revolution, transforming the country from food scarcity to food security. His research in plant genetics and breeding revolutionized crop production. Pioneer in sustainable agriculture and biodiversity conservation with global recognition. His work continues to influence agricultural policy and food security strategies worldwide.",
      whatsapp: "+91 98765 43221",
      contact: "+91 98765 43221",
      email: "swaminathan@mssrf.res.in"
    },
    {
      name: "Dr. Vijay Bhatkar",
      designation: "Computer Scientist",
      organization: "C-DAC",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Pioneer in supercomputing who led the development of India's first supercomputer PARAM. His vision established India's capabilities in high-performance computing and parallel processing. Architect of India's IT revolution through innovative computing solutions and technology development. His contributions to computer science education have shaped generations of IT professionals.",
      whatsapp: "+91 98765 43222",
      contact: "+91 98765 43222",
      email: "vijay.bhatkar@cdac.in"
    },
    {
      name: "Prof. Rohini Godbole",
      designation: "Particle Physicist",
      organization: "IISc, Bangalore",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Renowned theoretical physicist specializing in high-energy physics and particle phenomenology. Her research on collider physics and beyond Standard Model theories has international recognition. Pioneer in promoting women's participation in physics through mentorship and advocacy. Her contributions to physics education and research have inspired countless students and researchers.",
      whatsapp: "+91 98765 43223",
      contact: "+91 98765 43223",
      email: "rohini@iisc.ac.in"
    },
    {
      name: "Dr. K. Kasturirangan",
      designation: "Former Chairman",
      organization: "ISRO",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Distinguished space scientist who led ISRO through significant achievements in satellite technology and space exploration. His leadership resulted in successful missions and technological breakthroughs in space science. Expert in remote sensing and space applications with contributions to Earth observation systems. His vision for space technology applications has benefited various sectors including agriculture and disaster management.",
      whatsapp: "+91 98765 43224",
      contact: "+91 98765 43224",
      email: "kasturirangan@isro.gov.in"
    },
    {
      name: "Prof. Jayant Narlikar",
      designation: "Astrophysicist",
      organization: "IUCAA, Pune",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Eminent astrophysicist known for his contributions to cosmology and alternative theories of gravitation. His research on steady-state cosmology and quasi-stellar objects has international acclaim. Pioneer in astronomy education and popularization through books and lectures. His work in establishing IUCAA has strengthened India's position in astronomical research and education.",
      whatsapp: "+91 98765 43225",
      contact: "+91 98765 43225",
      email: "narlikar@iucaa.in"
    },
    {
      name: "Dr. Raghunath Mashelkar",
      designation: "Chemical Engineer",
      organization: "NCL, Pune",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Renowned chemical engineer and innovation expert who transformed India's R&D landscape. His research in transport phenomena and polymer processing has global recognition. Pioneer in technology transfer and innovation management with significant contributions to industrial research. His leadership in promoting innovation and entrepreneurship has influenced India's technology policy.",
      whatsapp: "+91 98765 43226",
      contact: "+91 98765 43226",
      email: "ramashelkar@ncl.res.in"
    },
    {
      name: "Prof. Udupi Ramachandra Rao",
      designation: "Space Scientist",
      organization: "ISRO",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Legendary space scientist who played a pivotal role in establishing India's satellite program. His contributions to satellite technology and space research earned him the title 'Satellite Man of India'. Pioneer in space science with significant achievements in cosmic ray physics and satellite development. His vision and leadership laid the foundation for India's success in space technology.",
      whatsapp: "+91 98765 43227",
      contact: "+91 98765 43227",
      email: "urrao@isro.gov.in"
    },
    {
      name: "Dr. Srinivasan Ramani",
      designation: "Computer Scientist",
      organization: "TIFR, Mumbai",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Pioneer in computer science who contributed significantly to India's early computing infrastructure. His work in computer systems and networking laid the groundwork for India's IT revolution. Expert in distributed computing and computer networks with innovative contributions to system design. His leadership in establishing computing facilities has benefited generations of researchers and students.",
      whatsapp: "+91 98765 43228",
      contact: "+91 98765 43228",
      email: "ramani@tifr.res.in"
    },
    {
      name: "Prof. Pushpa Mittra Bhargava",
      designation: "Molecular Biologist",
      organization: "CCMB, Hyderabad",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Visionary molecular biologist who established the Centre for Cellular and Molecular Biology. His research in reproductive biology and biotechnology has international recognition. Pioneer in science policy and administration with significant contributions to biotechnology development in India. His advocacy for scientific temper and rational thinking has influenced science education and policy.",
      whatsapp: "+91 98765 43229",
      contact: "+91 98765 43229",
      email: "pmbhargava@ccmb.res.in"
    },
    {
      name: "Dr. Anil Kakodkar",
      designation: "Nuclear Scientist",
      organization: "BARC, Mumbai",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Distinguished nuclear scientist who led India's nuclear program with expertise in reactor physics and nuclear fuel cycle. His contributions to nuclear technology and energy policy have strengthened India's energy security. Pioneer in nuclear reactor design and safety with significant achievements in thorium-based nuclear technology. His leadership has positioned India as a responsible nuclear power.",
      whatsapp: "+91 98765 43230",
      contact: "+91 98765 43230",
      email: "kakodkar@barc.gov.in"
    },
    {
      name: "Prof. Goverdhan Mehta",
      designation: "Organic Chemist",
      organization: "IISc, Bangalore",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Eminent organic chemist known for his contributions to synthetic organic chemistry and natural product synthesis. His research on complex molecular architectures has advanced understanding of chemical reactivity. Pioneer in stereochemistry and molecular design with significant contributions to drug discovery. His mentorship has produced numerous successful chemists and researchers worldwide.",
      whatsapp: "+91 98765 43231",
      contact: "+91 98765 43231",
      email: "gmehta@iisc.ac.in"
    },
    {
      name: "Dr. Balram Bhargava",
      designation: "Cardiologist",
      organization: "AIIMS, New Delhi",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Renowned cardiologist and medical researcher who has significantly advanced cardiovascular medicine in India. His clinical research and innovative treatment approaches have improved cardiac care outcomes. Pioneer in interventional cardiology with contributions to medical education and healthcare policy. His leadership during health crises has demonstrated the importance of evidence-based medical practice.",
      whatsapp: "+91 98765 43232",
      contact: "+91 98765 43232",
      email: "balram@aiims.edu"
    },
    {
      name: "Prof. Sanghamitra Bandyopadhyay",
      designation: "Computer Scientist",
      organization: "ISI, Kolkata",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Distinguished computer scientist specializing in machine learning, pattern recognition, and bioinformatics. Her research in computational intelligence and data mining has international recognition. Pioneer in applying AI techniques to biological problems with significant contributions to genomics research. Her leadership in promoting women in computing has inspired many female researchers in STEM fields.",
      whatsapp: "+91 98765 43233",
      contact: "+91 98765 43233",
      email: "sanghami@isical.ac.in"
    },
    {
      name: "Dr. K. VijayRaghavan",
      designation: "Former Principal Scientific Adviser",
      organization: "Government of India",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
      profile: "Eminent developmental biologist who served as Principal Scientific Adviser to the Government of India. His research in neurobiology and developmental genetics has advanced understanding of biological systems. Pioneer in science policy and administration with significant contributions to India's scientific infrastructure. His vision for science-driven development has influenced national research priorities and innovation strategies.",
      whatsapp: "+91 98765 43234",
      contact: "+91 98765 43234",
      email: "kvijayraghavan@gov.in"
    }
  ];

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.designation.trim()) newErrors.designation = 'Designation is required';
    if (!formData.organization.trim()) newErrors.organization = 'Organization is required';
    if (!formData.profile.trim()) {
      newErrors.profile = 'Profile is required';
    } else if (formData.profile.trim().split(' ').length < 50 || formData.profile.trim().split(' ').length > 100) {
      newErrors.profile = 'Profile must be between 50-100 words';
    }
    if (!formData.whatsapp.trim()) {
      newErrors.whatsapp = 'WhatsApp number is required';
    } else if (!/^\d{10}$/.test(formData.whatsapp.replace(/\D/g, ''))) {
      newErrors.whatsapp = 'WhatsApp number must be 10 digits';
    }
    if (!formData.contact.trim()) {
      newErrors.contact = 'Contact number is required';
    } else if (!/^\d{10}$/.test(formData.contact.replace(/\D/g, ''))) {
      newErrors.contact = 'Contact number must be 10 digits';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.photo) newErrors.photo = 'Photo is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    setSubmitStatus('');
    
    try {
      const emailData = {
        to: 'nirmala21549@gmail.com',
        subject: 'New Legends Application',
        html: `
          <h2>New Legends Application</h2>
          <p><strong>Name:</strong> ${formData.name}</p>
          <p><strong>Designation:</strong> ${formData.designation}</p>
          <p><strong>Organization:</strong> ${formData.organization}</p>
          <p><strong>Profile:</strong> ${formData.profile}</p>
          <p><strong>WhatsApp:</strong> ${formData.whatsapp}</p>
          <p><strong>Contact:</strong> ${formData.contact}</p>
          <p><strong>Email:</strong> ${formData.email}</p>
        `
      };
      
      await sendEmail(emailData);
      setSubmitStatus('success');
      setTimeout(() => {
        setShowApplication(false);
        setFormData({ name: '', designation: '', organization: '', profile: '', whatsapp: '', contact: '', email: '', photo: null });
        setSubmitStatus('');
      }, 2000);
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'photo') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const PosterPreview = () => (
    <div style={{
      width: '300px',
      height: '400px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '15px',
      padding: '20px',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
    }}>
      <div style={{
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: formData.photo ? 'transparent' : '#ffffff30',
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        border: '3px solid white'
      }}>
        {formData.photo ? (
          <img src={URL.createObjectURL(formData.photo)} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span style={{ fontSize: '0.8rem', textAlign: 'center' }}>Photo Preview</span>
        )}
      </div>
      <h3 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: '8px', textAlign: 'center' }}>
        {formData.name || 'Your Name'}
      </h3>
      <p style={{ fontSize: '0.9rem', marginBottom: '6px', textAlign: 'center', opacity: 0.9 }}>
        {formData.designation || 'Your Designation'}
      </p>
      <p style={{ fontSize: '0.85rem', marginBottom: '15px', textAlign: 'center', opacity: 0.8 }}>
        {formData.organization || 'Your Organization'}
      </p>
      <div style={{
        backgroundColor: '#ffffff20',
        borderRadius: '8px',
        padding: '10px',
        fontSize: '0.75rem',
        textAlign: 'center',
        lineHeight: '1.3',
        maxHeight: '120px',
        overflow: 'hidden'
      }}>
        {formData.profile || 'Your profile description will appear here...'}
      </div>
      <div style={{ marginTop: 'auto', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', opacity: 0.8 }}>ESN PUBLICATIONS</div>
        <div style={{ fontSize: '0.6rem', opacity: 0.6 }}>LEGENDS SERIES</div>
      </div>
    </div>
  );

  if (selectedLegend) {
    return (
      <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', paddingTop: '80px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
          <button
            onClick={() => setSelectedLegend(null)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#667eea',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              marginBottom: '30px'
            }}
          >
            <ArrowLeft size={20} />
            Back to Legends
          </button>

          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '50px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '50px', alignItems: 'start' }}>
              {/* Photo Section */}
              <div style={{ textAlign: 'center' }}>
                <div style={{ position: 'relative', display: 'inline-block', marginBottom: '20px' }}>
                  <img 
                    src={selectedLegend.image} 
                    alt={selectedLegend.name}
                    style={{ 
                      width: '250px', 
                      height: '300px', 
                      borderRadius: '15px',
                      objectFit: 'cover',
                      border: '5px solid #667eea',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: '-10px',
                    right: '-10px',
                    backgroundColor: '#ffd700',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 5px 15px rgba(255, 215, 0, 0.4)'
                  }}>
                    <Star size={24} color="white" fill="white" />
                  </div>
                </div>
              </div>

              {/* Details Section */}
              <div>
                <h1 style={{ 
                  color: '#2d3748', 
                  fontSize: '2.5rem', 
                  fontWeight: 700, 
                  marginBottom: '15px',
                  lineHeight: '1.2'
                }}>
                  {selectedLegend.name}
                </h1>
                
                <p style={{ 
                  color: '#667eea', 
                  fontSize: '1.3rem', 
                  fontWeight: 600,
                  marginBottom: '10px' 
                }}>
                  {selectedLegend.designation}
                </p>
                
                <p style={{ 
                  color: '#4a5568', 
                  fontSize: '1.1rem',
                  fontWeight: 500,
                  marginBottom: '30px' 
                }}>
                  {selectedLegend.organization}
                </p>

                {/* Profile */}
                <div style={{ marginBottom: '40px' }}>
                  <h3 style={{ 
                    color: '#2d3748', 
                    fontSize: '1.3rem', 
                    fontWeight: 700, 
                    marginBottom: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <BookOpen size={20} color="#667eea" />
                    Profile
                  </h3>
                  <p style={{ 
                    color: '#4a5568', 
                    fontSize: '1rem',
                    lineHeight: '1.7',
                    textAlign: 'justify'
                  }}>
                    {selectedLegend.profile}
                  </p>
                </div>

                {/* Contact Information */}
                <div style={{
                  background: 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)',
                  borderRadius: '15px',
                  padding: '30px'
                }}>
                  <h3 style={{ 
                    color: '#2d3748', 
                    fontSize: '1.3rem', 
                    fontWeight: 700, 
                    marginBottom: '25px'
                  }}>
                    Contact Information
                  </h3>
                  
                  <div style={{ display: 'grid', gap: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{
                        backgroundColor: '#25d366',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <MessageCircle size={20} color="white" />
                      </div>
                      <div>
                        <div style={{ color: '#4a5568', fontSize: '0.9rem', fontWeight: 500 }}>WhatsApp</div>
                        <div style={{ color: '#2d3748', fontSize: '1.1rem', fontWeight: 600 }}>{selectedLegend.whatsapp}</div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{
                        backgroundColor: '#667eea',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <Phone size={20} color="white" />
                      </div>
                      <div>
                        <div style={{ color: '#4a5568', fontSize: '0.9rem', fontWeight: 500 }}>Contact Number</div>
                        <div style={{ color: '#2d3748', fontSize: '1.1rem', fontWeight: 600 }}>{selectedLegend.contact}</div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{
                        backgroundColor: '#e53e3e',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <Mail size={20} color="white" />
                      </div>
                      <div>
                        <div style={{ color: '#4a5568', fontSize: '0.9rem', fontWeight: 500 }}>Email ID</div>
                        <div style={{ color: '#2d3748', fontSize: '1.1rem', fontWeight: 600 }}>{selectedLegend.email}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showApplication) {
    return (
      <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', paddingTop: '80px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
          <button
            onClick={() => setShowApplication(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#667eea',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              marginBottom: '30px'
            }}
          >
            <ArrowLeft size={20} />
            Back to Legends
          </button>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 350px', gap: '40px', alignItems: 'start' }}>
            {/* Form */}
            <div style={{
              backgroundColor: 'white',
              padding: '40px',
              borderRadius: '15px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}>
              <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '30px' }}>
                Apply to be a Legend
              </h2>

              {submitStatus === 'success' && (
                <div style={{
                  backgroundColor: '#c6f6d5',
                  color: '#22543d',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  textAlign: 'center',
                  fontWeight: 600
                }}>
                  Application submitted successfully!
                </div>
              )}

              {submitStatus === 'error' && (
                <div style={{
                  backgroundColor: '#fed7d7',
                  color: '#c53030',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  textAlign: 'center',
                  fontWeight: 600
                }}>
                  Application failed. Please try again.
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ display: 'grid', gap: '25px' }}>
                  <div>
                    <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'block' }}>Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: errors.name ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none'
                      }}
                    />
                    {errors.name && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.name}</span>}
                  </div>

                  <div>
                    <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'block' }}>Designation *</label>
                    <input
                      type="text"
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: errors.designation ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none'
                      }}
                    />
                    {errors.designation && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.designation}</span>}
                  </div>

                  <div>
                    <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'block' }}>Organization Name *</label>
                    <input
                      type="text"
                      name="organization"
                      value={formData.organization}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: errors.organization ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none'
                      }}
                    />
                    {errors.organization && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.organization}</span>}
                  </div>

                  <div>
                    <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'block' }}>Photo *</label>
                    <input
                      type="file"
                      name="photo"
                      accept="image/*"
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: errors.photo ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none'
                      }}
                    />
                    {errors.photo && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.photo}</span>}
                  </div>

                  <div>
                    <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                      Profile (50-100 words) *
                      <span style={{ color: '#718096', fontSize: '0.9rem', fontWeight: 400 }}>
                        {' '}({formData.profile.trim().split(' ').filter(word => word).length} words)
                      </span>
                    </label>
                    <textarea
                      name="profile"
                      value={formData.profile}
                      onChange={handleChange}
                      rows={4}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: errors.profile ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none',
                        resize: 'vertical'
                      }}
                    />
                    {errors.profile && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.profile}</span>}
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div>
                      <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MessageCircle size={16} />
                        WhatsApp Number *
                      </label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleChange}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: errors.whatsapp ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                          borderRadius: '8px',
                          fontSize: '1rem',
                          outline: 'none'
                        }}
                      />
                      {errors.whatsapp && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.whatsapp}</span>}
                    </div>

                    <div>
                      <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Phone size={16} />
                        Contact Number *
                      </label>
                      <input
                        type="tel"
                        name="contact"
                        value={formData.contact}
                        onChange={handleChange}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: errors.contact ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                          borderRadius: '8px',
                          fontSize: '1rem',
                          outline: 'none'
                        }}
                      />
                      {errors.contact && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.contact}</span>}
                    </div>
                  </div>

                  <div>
                    <label style={{ color: '#2d3748', fontWeight: 600, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Mail size={16} />
                      Email ID *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: errors.email ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        outline: 'none'
                      }}
                    />
                    {errors.email && <span style={{ color: '#e53e3e', fontSize: '0.9rem' }}>{errors.email}</span>}
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    style={{
                      width: '100%',
                      padding: '16px',
                      backgroundColor: isSubmitting ? '#a0aec0' : '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      marginTop: '10px'
                    }}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </button>
                </div>
              </form>
            </div>

            {/* Poster Preview */}
            <div style={{ position: 'sticky', top: '100px' }}>
              <h3 style={{ color: '#2d3748', fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px', textAlign: 'center' }}>
                Poster Preview
              </h3>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <PosterPreview />
              </div>
              <p style={{ color: '#718096', fontSize: '0.9rem', textAlign: 'center', marginTop: '15px' }}>
                This is how your poster will look when published
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section className="hero-section text-center" style={{ 
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9)), url("https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="container-custom">
          <h1 className="heading-1 text-white mb-6">Legends in Academia</h1>
          <p className="body-large text-white mb-8" style={{ maxWidth: '700px', margin: '0 auto 2rem', opacity: 0.95 }}>
            Honoring the distinguished minds who have shaped research, innovation, and academic excellence
          </p>
          <button
            onClick={() => setShowApplication(true)}
            style={{
              padding: '18px 40px',
              background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
              color: '#744210',
              border: 'none',
              borderRadius: '30px',
              fontSize: '1.2rem',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              boxShadow: '0 8px 25px rgba(255, 215, 0, 0.3)'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            🏆 Apply to be a Legend
          </button>
        </div>
      </section>

      <div className="container-custom" style={{ padding: '80px 24px' }}>
        {/* Legends Grid */}
        <div style={{ marginBottom: '80px' }}>
          <h2 style={{ 
            textAlign: 'center', 
            marginBottom: '20px', 
            color: '#2d3748', 
            fontSize: '2.5rem', 
            fontWeight: 700 
          }}>
            Our Distinguished Legends
          </h2>
          <p style={{ 
            textAlign: 'center', 
            marginBottom: '60px', 
            color: '#718096', 
            fontSize: '1.2rem',
            maxWidth: '600px',
            margin: '0 auto 60px'
          }}>
            Celebrating the remarkable individuals who have made extraordinary contributions to their fields
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
            gap: '30px' 
          }}>
            {legends.map((legend, index) => (
              <div key={index} style={{ 
                background: 'linear-gradient(135deg, #667eea20 0%, #764ba210 100%)',
                padding: '3px',
                borderRadius: '20px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{ 
                  backgroundColor: 'white', 
                  borderRadius: '17px',
                  padding: '30px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ position: 'relative', display: 'inline-block', alignSelf: 'center', marginBottom: '20px' }}>
                    <img 
                      src={legend.image} 
                      alt={legend.name}
                      style={{ 
                        width: '120px', 
                        height: '120px', 
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '4px solid #667eea'
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '5px',
                      backgroundColor: '#ffd700',
                      borderRadius: '50%',
                      width: '35px',
                      height: '35px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 4px 12px rgba(255, 215, 0, 0.3)'
                    }}>
                      <Star size={18} color="white" fill="white" />
                    </div>
                  </div>
                  
                  <h3 style={{ 
                    color: '#2d3748', 
                    fontSize: '1.3rem', 
                    fontWeight: 700, 
                    marginBottom: '8px',
                    lineHeight: '1.3'
                  }}>
                    {legend.name}
                  </h3>
                  
                  <p style={{ 
                    color: '#667eea', 
                    fontWeight: 600, 
                    fontSize: '1rem',
                    marginBottom: '6px' 
                  }}>
                    {legend.designation}
                  </p>
                  
                  <p style={{ 
                    color: '#4a5568', 
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    marginBottom: '20px',
                    flexGrow: 1
                  }}>
                    {legend.organization}
                  </p>
                  
                  <button 
                    onClick={() => setSelectedLegend(legend)}
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '25px',
                      fontSize: '0.95rem',
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      marginTop: 'auto'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#5a67d8'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#667eea'}
                  >
                    View Profile
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '3px',
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(102, 126, 234, 0.3)'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '17px',
            padding: '60px 40px',
            textAlign: 'center'
          }}>
            <h2 style={{ 
              color: '#2d3748', 
              fontSize: '2.5rem', 
              fontWeight: 700, 
              marginBottom: '20px' 
            }}>
              Join the Hall of Fame
            </h2>
            <p style={{ 
              color: '#718096', 
              fontSize: '1.2rem',
              marginBottom: '40px', 
              maxWidth: '700px', 
              margin: '0 auto 40px',
              lineHeight: '1.6'
            }}>
              Have you made significant contributions to your field? Apply to be featured in our Legends series 
              and inspire the next generation of researchers and academics.
            </p>
            <div style={{ 
              display: 'flex', 
              gap: '20px', 
              justifyContent: 'center', 
              flexWrap: 'wrap' 
            }}>
              <button 
                onClick={() => setShowApplication(true)}
                style={{
                  padding: '18px 40px',
                  background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
                  color: '#744210',
                  border: 'none',
                  borderRadius: '30px',
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
              >
                🏆 Apply Now
              </button>
              <button style={{
                padding: '18px 40px',
                backgroundColor: 'white',
                color: '#667eea',
                border: '2px solid #667eea',
                borderRadius: '30px',
                fontSize: '1.1rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#667eea';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#667eea';
                e.target.style.transform = 'translateY(0)';
              }}>
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legends;